"use strict";
exports.__esModule = true;
var util = require("util");
/**
 * @hidden
 */
// @ts-ignore -- see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30241
exports.inspect = util.inspect.custom;
//# sourceMappingURL=Value.js.map